import * as React from "react";
import Slider from "react-slick";

import { ResponsivenessSetting, useResponsiveness } from "../hooks";

import { PresentationThemeProduct } from "../model";

import { ProductSlide } from "./product-slide";

interface ProductSliderProps {
  products: PresentationThemeProduct[];
}

export const ProductSlider: React.FunctionComponent<ProductSliderProps> = (
  props
) => {
  const [responsivenessSetting] = useResponsiveness();

  return (
    <div className="product-slider">
      <Slider
        className="product-items"
        infinite
        dots={false}
        arrows={true}
        lazyLoad="ondemand"
        slidesToShow={
          responsivenessSetting === ResponsivenessSetting.Desktop
            ? 4
            : responsivenessSetting === ResponsivenessSetting.Tablet
            ? 3
            : 1
        }
        centerMode={responsivenessSetting === ResponsivenessSetting.Mobile}
        centerPadding={`${
          responsivenessSetting === ResponsivenessSetting.Mobile
            ? "68px"
            : "0px"
        }`}
      >
        {props.products.map((product) => {
          return (
            <div className="product">
              <ProductSlide key={product.id} product={product} />
            </div>
          );
        })}
      </Slider>
    </div>
  );
};
